module.exports = __webpack_public_path__ + "img/zhoumo.258b1308.png";